import { render, staticRenderFns } from "./AbonementGlobalContents.vue?vue&type=template&id=dd0680b0&scoped=true&lang=pug&"
import script from "./AbonementGlobalContents.vue?vue&type=script&lang=js&"
export * from "./AbonementGlobalContents.vue?vue&type=script&lang=js&"
import style0 from "./AbonementGlobalContents.vue?vue&type=style&index=0&id=dd0680b0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0680b0",
  null
  
)

/* custom blocks */
import block0 from "./AbonementGlobalContents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports